import React, { useCallback, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import './App.css';
import { getStatus, login, logout } from './api';
import Login from './Login';
import Gallery from './Gallery';

const swalDark = {
  background: '#171310',
  color: '#f0e9df',
  confirmButtonColor: '#e13a2e',
};

export default function App() {
  const [checking, setChecking] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [passwordSet, setPasswordSet] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [loginError, setLoginError] = useState('');

  const checkStatus = useCallback(async () => {
    setChecking(true);
    try {
      const data = await getStatus();
      setLoggedIn(!!data.loggedIn);
      setPasswordSet(!!data.passwordSet);
    } catch (err) {
      // Backend nedostupný - necháme uživatele u přihlašovací obrazovky s chybou při pokusu.
      setLoggedIn(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    checkStatus();
  }, [checkStatus]);

  const handleLoginSubmit = async (password) => {
    setSubmitting(true);
    setLoginError('');
    try {
      const res = await login(password);
      if (!res.success) throw new Error(res.message || 'Přihlášení se nezdařilo.');
      setLoggedIn(true);
      if (res.mode === 'created') {
        Swal.fire({
          ...swalDark,
          title: 'Heslo nastaveno',
          text: 'Od teď se jím budeš přihlašovat do administrace.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      setLoginError(err.message || 'Přihlášení se nezdařilo.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      setLoggedIn(false);
    }
  };

  if (checking) {
    return (
      <div className="page">
        <div className="state">
          <p>Ověřuji přihlášení…</p>
        </div>
      </div>
    );
  }

  if (!loggedIn) {
    return (
      <Login
        passwordSet={passwordSet}
        onSubmit={handleLoginSubmit}
        submitting={submitting}
        error={loginError}
      />
    );
  }

  return <Gallery onLogout={handleLogout} />;
}
